import React, { useCallback, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { destroy, index, search } from '../../api/ioCredentialsApi';
import { Stack } from '@mui/system';
import { Button, Card, Grid, IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import { Add, Delete, Edit, Search } from '@mui/icons-material';
import MercadappDialog from '../../components/MercadappDialog';
import withShowAlert from '../../components/withShowAlert';
import FormDialog from './FormDialog';
import { useNavigate } from 'react-router-dom';
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from '@mui/icons-material/Clear';


function IoCredentials({ showAlert }) {

  let navigate = useNavigate();
  const columns = [
    {
      field: 'brand_name',
      headerName: 'Marca',
      flex: 1
    },
    {
      field: 'market_name',
      headerName: 'Loja',
      flex: 1
    }, 
    {
      field: 'app_id',
      headerName: 'Credencial',
      flex: 1
    },
    
    {
      headerName: 'Ações',
      flex: 1,
      renderCell: (params) => (
        <Stack direction="horizontal">
          <Tooltip title="Pesquisar">
            <IconButton onClick={() => navigate(`/io_credentials/${params.row.id}`)}>
              <Search />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar">
            <IconButton onClick={() => setFormModalInfo({ editingModel: params.row, open: true })}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir">
            <IconButton onClick={() => setDeleteModalOpen({ id: params.row.id, open: true })}>
              <Delete />
            </IconButton>
          </Tooltip>
        </Stack>
      )
    }
  ];

  const [formModalInfo, setFormModalInfo] = useState({ editingModel: null, open: false })
  const [cancelModalInfo, setDeleteModalOpen] = useState({ id: null, loading: false, open: false })
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [rowCount, setRowCount] = useState(0)
  const [searchText, setSearchText] = useState("")

  const loadData = useCallback(async () => {
    setIsLoading(true)
    const response = await index(currentPage)
    setData(response.data.data)
    setRowCount(response.data.total_count)
    setIsLoading(false)
  }, [currentPage])

  const callDestroyRequest = async (credentialId) => {
    try {
      await destroy(credentialId)
      showAlert('Deletado com sucesso', 'success')
      loadData()
    } catch (error) {
      console.log(error)
      showAlert('Falha ao deletar.', 'error')
    }
  }

  const searchCredentials = async (query) => {
    setIsLoading(true)
    try {
      const { data } = await search(query.toLocaleLowerCase())
      setData(data.data)
      setRowCount(data.total_count)
    } catch (error) {
      console.log(error)
      showAlert('Falha ao pesquisar.', 'error')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (searchText === "") {
      loadData()
    }
  }, [loadData, searchText])

  return (
    <Box sx={{ height: '82vh', width: '100%' }}>
      {formModalInfo.open &&
        <FormDialog
          editingModel={formModalInfo.editingModel}
          open={formModalInfo.open}
          setOpen={(open, reload, message) => {
            setFormModalInfo({ ...formModalInfo, open: open })
            if (reload) {
              showAlert(message, "success")
              loadData()
            }
          }} />
      }
      <MercadappDialog title="Tem certeza?" message="O registro selecionado será removido permanentemente."
        open={cancelModalInfo.open}
        setOpen={(open) => setDeleteModalOpen({ ...cancelModalInfo, open: open })}
        buttons={
          [{
            text: "Cancelar", color: "primary", action: () => {
              setDeleteModalOpen({ open: false, id: null })
            }
          }]
        }
        loadingButtons={[{
          text: "Confirmar",
          loading: cancelModalInfo.loading,
          color: "error",
          action: () => {
            callDestroyRequest(cancelModalInfo.id)
            setDeleteModalOpen({ open: false, id: null })
          }
        }]} />
      <Grid justifyContent="end" container mb={2}>
        <Button startIcon={<Add />} variant="contained" color="success" onClick={() => setFormModalInfo({ editingModel: null, open: true })}>
          Novo
        </Button>
      </Grid>
      <Card>
        <Box sx={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          height: 48,
        }}
        mt={1}
        mb={2}>
        <TextField fullWidth sx={{ m: 1 }} label="Pesquisar credenciais"
          value={searchText}
          variant="standard"
          onChange={({ target }) => setSearchText(target.value)}
          InputProps={{
            endAdornment: searchText !== "" ? (
              <InputAdornment>
                <Tooltip title="Limpar busca">
                  <IconButton sx={{ mb: 1 }}color="primary" onClick={() => setSearchText("")}>
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ) : null,
          }}
          />
          <Button
          sx={{ height: "100%", mr: 1 }}
          variant="contained"
          color="primary"
          startIcon={<SearchIcon />}
          onClick={() => searchCredentials(searchText)}
        >
          Pesquisar
        </Button>
        </Box>
      <DataGrid
        rows={data || []}
        columns={columns}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 25, page: currentPage },
          },
        }}
        rowsPerPageOptions={[25]}
        pagination
        page={currentPage}
        pageSize={5}
        rowCount={rowCount}
        autoHeight={true}
        paginationMode="server"
        onPaginationModelChange={(newPaginationModel) => setCurrentPage(newPaginationModel.page)}
        disableSelectionOnClick
        hideFooterSelectedRowCount={true}
        disableColumnSelector
        disableColumnMenu
        disableColumnFilter
        sx={{
          '.MuiTablePagination-displayedRows': {
            display: 'none'
          },
          '.MuiTablePagination-selectLabel': {
            display: 'none'
          },
          '.MuiInputBase-root': {
            display: 'none'
          }, '.MuiTablePagination-input': {
            display: 'none',
          },
        }}

      />
      </Card>
    </Box >
  );
}

export default withShowAlert(IoCredentials)